import { Check } from '@styled-icons/bootstrap'
import { Cross } from '@styled-icons/entypo'

function PriceSection() {
	return (
		<section className='mt-[50px]' id='prices'>
			<div className='flex flex-col items-center'>
				<p className='text-center text-black dark:text-white font-medium text-[20px] sm:text-[26px] xl:text-[32px]'>
					Тарифные планы
				</p>
				<p className='mt-[15px] text-dark-100 sm:mt-[25px] text-center w-[300px] sm:w-[360px]'>
					Здесь вы сможете подобрать тариф под себя, узнать стоимость
					услуг и их возможности.
				</p>
			</div>
			<div className='mt-[25px] sm:mt-[50px] grid grid-cols-1 sm:grid-cols-2 gap-[25px]'>
				<div className='bg-white dark:bg-dark-300 w-full pt-[54px] px-[24px] pb-[25px]'>
					<p className='text-black dark:text-white text-center text-[24px] font-semibold'>
						Бюджетный
					</p>
					<p className='text-black dark:text-white text-center text-[32px] font-bold mt-[18px]'>
						$10.00{' '}
						<span className='text-dark-100 text-[16px] font-normal'>
							/Час
						</span>
					</p>
					<p className='text-dark-100 text-center mt-[8px]'>
						Для простых сайтов, не требующих высокой скорости и
						сложной логики
					</p>
					<div className='mt-[21px] flex flex-col'>
						<div className='flex items-center gap-[10px] py-[8px] xl:border-b border-[#FAFAFA]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Адаптивная вертка
							</p>
						</div>
						<div className='flex items-center gap-[10px] py-[8px] xl:border-b border-[#FAFAFA]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								UI Дизайн
							</p>
						</div>
						<div className='flex items-center gap-[10px] py-[8px] xl:border-b border-[#FAFAFA]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Установка на хостинг
							</p>
						</div>
						<div className='flex items-center gap-[10px] py-[8px] xl:border-b border-[#FAFAFA]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Доменное имя
							</p>
						</div>
						<div className='flex items-center gap-[10px] py-[8px] xl:border-b border-[#FAFAFA]'>
							<Cross className='w-[24px] fill-dark-100' />
							<p className='text-dark-100'>
								Форма обратной связи
							</p>
						</div>
						<div className='flex items-center gap-[10px] py-[8px] xl:border-b border-[#FAFAFA]'>
							<Cross className='w-[24px] fill-dark-100' />
							<p className='text-dark-100'>Форма заказа</p>
						</div>
						<div className='flex items-center gap-[10px] py-[8px] xl:border-b border-[#FAFAFA]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Посадка на Wordpress
							</p>
						</div>
						<div className='flex items-center gap-[10px] py-[8px] xl:border-b border-[#FAFAFA]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Админ-панель
							</p>
						</div>
						<div className='flex items-center gap-[10px] py-[8px] xl:border-b border-[#FAFAFA]'>
							<Cross className='w-[24px] fill-dark-100' />
							<p className='text-dark-100'>Онлайн консультант</p>
						</div>
						<div className='flex items-center gap-[10px] py-[8px] xl:border-b border-[#FAFAFA]'>
							<Cross className='w-[24px] fill-dark-100' />
							<p className='text-dark-100'>SEO Оптимизация</p>
						</div>
						<div className='flex items-center gap-[10px] py-[8px] xl:border-b border-[#FAFAFA]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>Иконки</p>
						</div>
						<div className='flex items-center gap-[10px] py-[8px] xl:border-b border-[#FAFAFA]'>
							<Cross className='w-[24px] fill-dark-100' />
							<p className='text-dark-100'>Анимация</p>
						</div>
						<div className='flex items-center gap-[10px] py-[8px] xl:border-b border-[#FAFAFA]'>
							<Cross className='w-[24px] fill-dark-100' />
							<p className='text-dark-100'>
								Интеграция с апи сервисов
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Cross className='w-[24px] fill-dark-100' />
							<p className='text-dark-100'>
								Онлайн обновление контента
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Cross className='w-[24px] fill-dark-100' />
							<p className='text-dark-100'>
								Кастомное написание модулей
							</p>
						</div>
						<div className='flex items-center gap-[10px] py-[8px]'>
							<Cross className='w-[24px] fill-dark-100' />
							<p className='text-dark-100'>
								Использование фреймворков
							</p>
						</div>
					</div>
					<div className='flex justify-center mt-[21px]'>
						<a
							href='https://t.me/TimPhp'
							className='flex items-center justify-center bg-white shadow-lg py-[11px] px-[40px] rounded-full text-[14px] text-black font-bold uppercase'
						>
							Купить сейчас
						</a>
					</div>
				</div>
				<div className='bg-white dark:bg-dark-300 w-full pt-[54px] px-[24px] pb-[25px] relative'>
					<p className='absolute top-0 left-0 flex items-center justify-center font-medium w-full bg-yellow-100 text-black h-[30px]'>
						Самое популярное
					</p>
					<p className='text-black dark:text-white text-center text-[24px] font-semibold'>
						Стандарт
					</p>
					<p className='text-black dark:text-white text-center text-[32px] font-bold mt-[18px]'>
						$15.00{' '}
						<span className='text-dark-100 text-[16px] font-normal'>
							/Час
						</span>
					</p>
					<p className='text-dark-100 text-center mt-[8px]'>
						Для сайтов с достаточной нагрузкой типов:
						интернет-магазина
					</p>
					<div className='mt-[21px] flex flex-col'>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Адаптивная вертка
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								UI Дизайн
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Установка на хостинг
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Доменное имя
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Форма обратной связи
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Форма заказа
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Посадка на Wordpress
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Админ-панель
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Онлайн консультант
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								SEO Оптимизация
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>Иконки</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Анимация
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Cross className='w-[24px] fill-dark-100' />
							<p className='text-dark-100'>
								Интеграция с апи сервисов
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Cross className='w-[24px] fill-dark-100' />
							<p className='text-dark-100'>
								Онлайн обновление контента
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Cross className='w-[24px] fill-dark-100' />
							<p className='text-dark-100'>
								Кастомное написание модулей
							</p>
						</div>
						<div className='flex items-center gap-[10px] py-[8px]'>
							<Cross className='w-[24px] fill-dark-100' />
							<p className='text-dark-100'>
								Использование фреймворков
							</p>
						</div>
					</div>
					<div className='flex justify-center mt-[21px]'>
						<a
							href='https://t.me/TimPhp'
							className='flex items-center justify-center bg-white shadow-lg py-[11px] px-[40px] rounded-full text-[14px] text-black font-bold uppercase'
						>
							Купить сейчас
						</a>
					</div>
				</div>
				<div className='bg-white dark:bg-dark-300 w-full pt-[54px] px-[24px] pb-[25px]'>
					<p className='text-black dark:text-white text-center text-[24px] font-semibold'>
						Бизнес
					</p>
					<p className='text-black dark:text-white text-center text-[32px] font-bold mt-[18px]'>
						$25.00{' '}
						<span className='text-dark-100 text-[16px] font-normal'>
							/Час
						</span>
					</p>
					<p className='text-dark-100 text-center mt-[8px]'>
						Под сайты с трудной логикой и высокой посещаемостью,
						таких типов как: форум
					</p>
					<div className='mt-[21px] flex flex-col'>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Адаптивная вертка
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								UI Дизайн
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Установка на хостинг
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Доменное имя
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Форма обратной связи
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Форма заказа
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Посадка на Wordpress
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Админ-панель
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Онлайн консультант
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								SEO Оптимизация
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>Иконки</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Анимация
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Интеграция с апи сервисов
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Онлайн обновление контента
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Cross className='w-[24px] fill-dark-100' />
							<p className='text-dark-100'>
								Кастомное написание модулей
							</p>
						</div>
						<div className='flex items-center gap-[10px] py-[8px]'>
							<Cross className='w-[24px] fill-dark-100' />
							<p className='text-dark-100'>
								Использование фреймворков
							</p>
						</div>
					</div>
					<div className='flex justify-center mt-[21px]'>
						<a
							href='https://t.me/TimPhp'
							className='flex items-center justify-center bg-white shadow-lg py-[11px] px-[40px] rounded-full text-[14px] text-black font-bold uppercase'
						>
							Купить сейчас
						</a>
					</div>
				</div>
				<div className='bg-white dark:bg-dark-300 w-full pt-[54px] px-[24px] pb-[25px]'>
					<p className='text-black dark:text-white text-center text-[24px] font-semibold'>
						Премиум
					</p>
					<p className='text-black dark:text-white text-center text-[32px] font-bold mt-[18px]'>
						$40.00{' '}
						<span className='text-dark-100 text-[16px] font-normal'>
							/Час
						</span>
					</p>
					<p className='text-dark-100 text-center mt-[8px]'>
						Сайты любых типов + разработка мобильных приложений,
						любого типа и сложности.
					</p>
					<div className='mt-[21px] flex flex-col'>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Адаптивная вертка
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								UI Дизайн
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Установка на хостинг
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Доменное имя
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Форма обратной связи
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Форма заказа
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Посадка на Wordpress
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Админ-панель
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Онлайн консультант
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								SEO Оптимизация
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>Иконки</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Анимация
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Интеграция с апи сервисов
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Онлайн обновление контента
							</p>
						</div>
						<div className='flex items-center gap-[10px] xl:border-b border-[#FAFAFA] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Кастомное написание модулей
							</p>
						</div>
						<div className='flex items-center gap-[10px] py-[8px]'>
							<Check className='w-[24px] fill-yellow-100' />
							<p className='text-black dark:text-white'>
								Использование фреймворков
							</p>
						</div>
					</div>
					<div className='flex justify-center mt-[21px]'>
						<a
							href='https://t.me/TimPhp'
							className='flex items-center justify-center bg-white shadow-lg py-[11px] px-[40px] rounded-full text-[14px] text-black font-bold uppercase'
						>
							Купить сейчас
						</a>
					</div>
				</div>
			</div>
		</section>
	)
}

export default PriceSection
